import React, { useState, useCallback } from 'react';
import RxPrescriberGroup from './RxPrescriberGroup';

function RxPrescriberGroupContainer(props) {
  const [showInactiveClaims, setShowInactiveClaims] = useState(false);
  const onToggleShowInactiveClaims = useCallback(() => setShowInactiveClaims(prev => !prev), []);
  return (
    <RxPrescriberGroup
      {...props}
      showInactiveClaims={showInactiveClaims}
      onToggleShowInactiveClaims={onToggleShowInactiveClaims}
    />
  );
}

export default RxPrescriberGroupContainer;
